import { Module } from 'core/Module';
import { Events } from 'core/events/Events';

export class VideoControls extends Module {
	public config = {
		target: null
	};

	private $video;
	private playing: boolean = false;

	public create(): void {
		this.$video = document.querySelector(this.config.target);

		Events.on('click', this.$video, () => {
			if (!this.playing) {
				this.$video.play();
				this.playing = true;
				this.DOM.addClass(this.$video, '-playing');
				this.DOM.removeClass(this.$video, '-notplaying');
			} else {
				this.$video.pause();
				this.playing = false;
				this.DOM.addClass(this.$video, '-notplaying');
				this.DOM.removeClass(this.$video, '-playing');
			}
		});
	}
}
